import React from 'react'
import {
    Spinner
}
from 'reactstrap';

export const SpinnerLoader = ({type, count, size}) => {

  type = type || 'grow';
  count = count || 3;
  size = size || 'md';

  return (
    <div>
      {[...Array(count)].map((e, i) =>
        <Spinner key={i} type={type} 
        size={size}
        color={
          i% 2 === 0 ? 'primary' : 'light'
        } />
      )}

  </div>
  )
}
